import axios, { AxiosResponse } from 'axios';
import { useAxios } from '@/features/common/helpers/axios';
import {
  CheckInPostDto, CheckInResponse, UserInfo,
} from '@/features/users/types';
import { CountryInfo } from '../types';

const { axiosService } = useAxios();

export const getUserIP = async (): Promise<string> => {
  const response = await axios.get('https://api.ipify.org/?format=json', {
    headers: {
      'Access-Control-Allow-Origin': '*',
    },
  });
  return response.data.ip;
};

// TODO: move to settings module
export const fetchUserInfo = async (): Promise<UserInfo | null> => {
  try {
    const userInfoRes: AxiosResponse = await axiosService.get('/settings/user-info');
    return userInfoRes.data;
  } catch {
    return null;
  }
};

export const getCountriesData = async (): Promise<CountryInfo[]> => {
  try {
    const countriesRes = await axiosService.get<CountryInfo[]>('/countries');
    return countriesRes.data;
  } catch {
    return [];
  }
};

export const postAccountCheckIn = async (
  data: CheckInPostDto,
): Promise<CheckInResponse | null> => {
  try {
    const checkInResponse = await axiosService.post<CheckInResponse>(
      '/account/check-in',
      data,
    );
    return checkInResponse.data;
  } catch {
    return null;
  }
};

export const trackCurrentPage = async (pageType: string): Promise<boolean> => {
  try {
    await axiosService.post(`/account/user-details/${pageType}`, {});
    return true;
  } catch {
    return false;
  }
};

export const addIntentionalDelay = async (time: number): Promise<void> => {
  if (!time) return;

  try {
    await axiosService.get(`/test-data/delay/${time}`);
  } catch {
    console.log('Error in intentional delay');
  }
};
